import { t } from "@/lib/i18n/interpolate";
import type { ExprError, ExprErrorCode } from "@/lib/tool-kit/calculus/parse";

/**
 * English wording for each way a formula can fail to parse, shared by the calculus
 * widgets (each spreads it into its own `*_STRINGS` so a translation can override it).
 */
export const EXPRESSION_ERROR_STRINGS: Record<ExprErrorCode, string> = {
  empty: "Type a function, such as x^2 sin(x).",
  "too-long": "That formula is too long; keep it under 300 characters.",
  "too-deep": "That formula is nested too deeply.",
  "unexpected-character":
    "“{token}” cannot be used in a formula. Use + − * / ^ and brackets.",
  "unexpected-token":
    "Something is missing or out of place near “{token}”. A number cannot follow a letter or a bracket without an operator: write x*2 or 2x.",
  "unexpected-end": "The formula ends too soon; is an operand missing?",
  "missing-paren": "A bracket is opened but never closed, or closed twice.",
  "unknown-function":
    "“{token}(” is not a known function. To multiply letters, write them one at a time (a*b*c); the functions are sin, cos, tan, sec, csc, cot, asin, acos, atan, sinh, cosh, tanh, exp, ln, log, sqrt and abs.",
  "inverse-notation":
    "“{token}^-1” is ambiguous: write asin(x), acos(x) or atan(x) for an inverse function, or 1/{token}(x) for the reciprocal.",
  "bar-notation": "Write the absolute value as abs(x) rather than |x|.",
};

export function expressionErrorMessage(
  error: ExprError,
  messages: Record<ExprErrorCode, string>
): string {
  return t(messages[error.code], { token: error.token });
}
